export default __webpack_public_path__ + "static/media/shefa-logo.fa6851d4.svg";